import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { ProductList } from "../model/finzy-flex/product-list.model";
import { ProductService } from "../service/finzy-flex/product/product.service";
import { Keys, StorageService } from "../service/storage.service";

@Injectable()
export class ProductResolver implements Resolve<any>{

    private readonly productService: ProductService;
    private readonly storageService: StorageService

    constructor(productService: ProductService, storageService: StorageService) {
        this.productService = productService;
        this.storageService = storageService;
    }

    async resolve(): Promise<ProductList> {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const applicableProducts = await this.productService.getSubProductsList('lender', lenderId);
        if (applicableProducts) {
            return applicableProducts;
        }
        return null;
    }
}